<template>
    <div class="container slider" id="slider-show">
        <div class="row" v-for="item in items" :key="item.id" style="display:none" v-bind:class="{ active: item.id == (ShowID % items.length)}" v-bind:id="'slider-show-' + item.id">
            <img v-lazy="item.image"/>                            
                    
                <h5 class="title">
                    <span class="d-block mb-1">{{item.title}}</span>
                    <small class="h6 text-muted">{{item.message}}</small>
                </h5>
                    
        </div>
        <div class="row paging">
            <span v-for="item in items" :key="item.id" v-on:click="ShowID = item.id"
                 v-bind:class="{ active: item.id == (ShowID % items.length)}" v-bind:id="'slider-show-li-' + item.id"></span>
        </div>
            <button class="arrow prev"><i class="fa fa-chevron-left" v-on:click="ShowID = prev(ShowID, items)"></i></button>
            <button class="arrow next"><i class="fa fa-chevron-right" v-on:click="ShowID = next(ShowID, items)"></i></button>
    </div>
            
<!--
    <div class="row">
        <div class="col-sm-4 col-6">
            <small class="d-block text-uppercase font-weight-bold mb-4">Đại lý Anh Hùng Phúc La, Hà Đông, Hà Nội</small>
            <img v-lazy="'img/theme/Untitled-4.png'" alt="Rounded image" class="img-fluid rounded-circle shadow"
                >
                 <p>Sau 1 thời gian sử dụng hệ thống bán hàng Ốc Ta anh đánh giá rất cao sự nhiệt tình của nhân viên trong công ty,trong quá trình bán hàng sử anh có thể mua được nhiều mệnh giá thẻ điện thoại, thẻ game rất nhanh, đa dạng, thuận tiện và không gặp bất cứ khó khăn gì về thiếu hàng hay sự cố trong quá trình giao dịch, và anh rất hài lòng khi sử dụng sản phẩm công ty Ốc Ta</p>
        </div>
        <div class="col-sm-4 col-6">
            <small class="d-block text-uppercase font-weight-bold mb-4">Chị Hoài  ngõ 9 Hoàng Cầu, Đống Đa, Hà Nội</small>
            <img v-lazy="'img/theme/Untitled-2.png'" alt="Circle image"
                 class="img-fluid rounded-circle shadow" >
                 <p>Sử dụng hệ thống bán hàng Ốc Ta chị đánh giá cao sản phẩm đa dạng,chị góp ý công ty nên bổ sung thêm chức năng trong mục báo cáo của đại lý để xem rõ hơn về doanh thu, lợi nhuận, đội ngũ nhân viên hỗ trợ nhiệt tình nhanh chóng, và chị rất hài lòng khi sử dụng sản phẩm công ty Ốc Ta.</p>
        </div>
        <div class="col-sm-4 col-6 mt-5 mt-sm-0">
            <small class="d-block text-uppercase font-weight-bold mb-4">Anh Hưng Yên Phúc, Phúc La, Hà Đông, Hà Nội </small>
            <img v-lazy="'img/theme/Untitled-5.png'" alt="Raised image" class="img-fluid rounded-circle shadow-lg"
                 >
                 <p>Hệ thống bán hàng Ốc Ta anh đánh giá rất cao sự nhiệt tình, thiện cảm của nhân viên trong công ty,anh rất hứng thú. Anh có thể mua được nhiều mệnh giá thẻ điện thoại, thẻ game rất nhanh, đa dạng, thuận tiện và không gặp bất cứ khó khăn gì về thiếu hàng hay sự cố trong quá trình giao dịch, và anh rất hài lòng khi sử dụng sản phẩm công ty Ốc Ta.</p>
        </div>
-->

</template>
<script>
export default {
    data() {
        return{
            log: (txt) => {
                console.log(txt)
            },
            items: [
                {
                    id: 0,
                    image: 'img/theme/Untitled-2.png',
                    title: 'Chị Hoài - Quản lý cửa hàng tiện lợi 24h chia sẻ',
                    message: 'Sau 1 thời gian sử dụng hệ thống bán hàng Ốc Ta chị đánh giá rất cao, dễ sử dụng, giao diện đẹp, đa dạng sản phẩm, rất thiện cảm cho người sử dụng, chức năng bảo mật của Ốc Ta hơn các hệ thống khác đã sử dụng trước kia cho người dùng và chị rất an tâm và hài lòng khi sử dụng sản phẩm công ty Ốc Ta'
                },
                {
                    id: 1,
                    image: 'img/theme/Untitled-4.png',
                    title: ' Anh Hùng - Quản lý đại lý chia sẻ',
                    message: 'Anh đánh giá hệ thống bán hàng của Ốc ta rất đa dạng sản phẩm. Anh góp ý công ty nên bổ sung thêm chức năng trong mục báo cáo của đại lý để xem rõ hơn về doanh thu, lợi nhuận, đội ngũ nhân viên hỗ trợ nhiệt tình nhanh chóng, và anh rất hài lòng khi sử dụng sản phẩm công ty Ốc Ta'
                },
                {
                    id: 2,
                    image: 'img/theme/Untitled-6.png',
                    title: ' Chị Thương Mễ Trì, Nam Từ Liêm, Hà Nội - Quản lý đại lý chia sẻ',
                    message: 'Hệ thống bán hàng Ốc Ta chị đánh giá giao diện hệ thống đẹp, thiện cảm, bên cạnh đó chị góp ý công ty nên tối ưu hóa một số thao tác sao chép trong quá trình giao dịch bán hàng và chị rất hài lòng khi sử dụng sản phẩm công ty'
                },
                {
                    id: 3,
                    image: 'img/theme/Untitled-5.png',
                    title: ' Anh Hưng Yên Phúc, Phúc La, Hà Đông, Hà Nội - Quản lý đại lý chia sẻ',
                    message: 'Anh đánh giá rất cao sự nhiệt tình của nhân viên trong công ty,anh rất hứng thú về giao diện hệ thống đẹp, thiện cảm cho người sử dụng, đa dạng sản phẩm, bên cạnh đó anh góp ý công ty nên xây dựng thêm ứng dụng app để thuận tiện khi sử dụng trên điện thoại.'
                },
                {
                    id: 4,
                    image: 'img/theme/Untitled-7.png',
                    title: ' Anh Nam ngõ 192 Lê Trọng Tấn, Hoàng Mai, Hà Nội - Quản lý cửa hàng game chia sẻ',
                    message: 'Sử dụng hệ thống bán hàng Ốc Ta anh đánh giá rất cao sự nhiệt tình của nhân viên trong công ty hỗ trợ anh rất nhiều trong thời gian ban đầu sử dụng hệ thống mới, anh rất hứng thú về giao diện hệ thống rất đẹp, bắt mắt, rất thiện cảm cho người sử dụng, đa dạng sản phẩm, thêm vào đó khi tôi sử dụng có thể mua được nhiều mệnh giá thẻ điện thoại, thẻ game rất nhanh, thuận tiện và không thiếu hàng hay sự cố trong quá trình giao dịch'
                },
            ],
            ShowID: 0
        }
    },
    methods: {
        next: (ShowID, items) => {
            return (ShowID + 1);
        },
        prev: (ShowID, items) => {        
            return (ShowID - 1);        
        },
        pollData () {
            const self = this;          
            self.polling = setInterval(() => {
                self.next(self.ShowID++, self.items);
            }, 8000);
        }
    },
    beforeDestroy () {
            clearInterval(this.polling)
        },
    created () {
        this.pollData()
    }
};

</script>
<style>
 #slider-show{
        position: relative;
    }
    #slider-show > div > img{
        float: left;padding: 0 20px; border-radius: 50%;
        height: 200px;
        widows: 200px;
    }
    #slider-show .paging{
        left: 50%;
        width: 100%;
        position: absolute;
        width: 140px;
        margin-left: -70px;        
    }

    #slider-show .paging span{
        cursor: pointer;
        background-color: white;
        height: 16px;
        width: 16px;
        margin: 2px;
        border: 1px solid #13b079;
        border-radius: 50%;        
    }
    #slider-show .paging span.active{
        background-color: #c2c2c2;
        font-weight: 400;
    }
    .arrow{
        position: absolute;
        border-radius: 15px;
        width: 30px;
        height: 30px;
        background-color: #13b079;
        color: white;
        border-color: #13b079;
        border-width: 0px;
        cursor: pointer;
        font-size: 1em;
    }
    .prev{
        top: 50%;
        left: -60px;
    }
    .next{
        top: 50%;
        right: -60px;
    }

    .active{
        display: block !important;
    }
    .title{
        max-height: 200px;
        min-height: 200px;
        overflow: hidden;
        text-align: justify;
    }
    @media (max-width: 768px)
    {
        #slider-show > div > img
        {
            float: inherit;
            width: 100%;
            margin-bottom: 30px;
        }
    }
</style>
